import i18n from '../i18n/config';
import { useTranslation } from 'react-i18next';
// Página dedicada del Asistente APS (modo pantalla completa).
import React, { useEffect } from 'react';
import { Container, Paper, Box, Typography, Avatar } from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import AssistantPanel from '../components/ai/AssistantPanel';
import { api } from '../services/api';

export default function AIAssistantPage() {
  const { t } = useTranslation();
  useEffect(() => { api.systemUsage.track('ai', 'chat_opened', { path: '/chat/ai' }); }, []);
  return (
    <Container maxWidth="md" disableGutters sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Paper sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden' }}>
        <Box sx={{ px: 2, py: 1.5, display: 'flex', alignItems: 'center', gap: 1.5,
          color: '#fff', background: 'linear-gradient(135deg, #1a1a1a 0%, #b71c1c 100%)' }}>
          <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.15)' }}><SmartToyIcon /></Avatar>
          <Box>
            <Typography variant="h6" fontWeight={700} lineHeight={1.1}>{i18n.t('hardcoded.components_ai_assistantlauncher.asistente_aps')}</Typography>
            <Typography variant="caption" sx={{ opacity: 0.85 }}>{t('hardcoded.pages_aiassistantpage.consulta_inteligente_sobre_tu_operacion')}</Typography>
          </Box>
        </Box>
        <Box sx={{ flex: 1, minHeight: 0 }}>
          <AssistantPanel />
        </Box>
      </Paper>
    </Container>
  );
}
